import React from 'react'
import { Form, Input, Switch, InputNumber } from 'antd'
import { RoleSettingsSection } from './RoleSettingsSection'

export const RoleForm = () => (
  <RoleSettingsSection
    title="Основные настройки"
    description="Название, состояние и стартовая страница для сотрудников с этой ролью."
  >
    <div className="role-basic-grid">
      <Form.Item
        label="Название роли"
        name="name"
        rules={[{ required: true, whitespace: true, message: 'Укажите название роли' }]}
      >
        <Input autoComplete="off" maxLength={255} />
      </Form.Item>
      <Form.Item label="Роль активна" name="is_active" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item label="Стартовая страница" name="start_page">
        <Input placeholder="Например, /orders" />
      </Form.Item>
      <Form.Item label="Приоритет" name="priority">
        <InputNumber precision={0} />
      </Form.Item>
    </div>
  </RoleSettingsSection>
)
